import {useMutation, useQuery} from "react-query";
import {SkinModel} from "./skinTypes";
import {getJsonServer, postJsonServer} from "../../axios/generic-api2-calls";
import {queryClient} from "../../App";

export function useFetchSkins(key:string = 'skins') {
    return useQuery<SkinModel[]>(key, () => getJsonServer('/skin?_sort=votes&_order=desc'));
}

export function useVoteForSkin(key:string = 'skin.vote') {
    return useMutation(key, (skinId: string) => postJsonServer(`/skin/${skinId}/vote`),
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries('skins');
            },
        }
    );
}
